const Groupings = {
    NONE: 'none',
    RUN: 'run',
    ATHLETE: 'athlete',
    ATHLETE_FULL_NAME: 'athleteFullName',
    ATHLETE_SHORT_NAME: 'athleteShortName'
};

export default Groupings;
